import styled from 'styled-components';
import { StepContainer } from '../StepContainer';

interface IProps {
    className?: string;
}

const BasePrivacyMessage = ({ className }: IProps) => (
    <StepContainer className={className}>
        <h3>
            <strong>Zorgvuldig omgaan met jouw privacy</strong>
        </h3>
        <p>
            Voor enkel inzage in jouw oogmeetgegevens, kun je terecht bij jouw
            GrandOptical winkel.
        </p>
        <a
            href="https://gv-groeneveld-ii.webflow.io/opticien"
            rel="noreferrer"
            target="_blank"
        >
            Vind je dichtstbijzijnde GrandOptical winkel
        </a>
    </StepContainer>
);

export const PrivacyMessage = styled(BasePrivacyMessage)`
    p {
        line-height: 2;
        margin-bottom: 24px;
    }
`;
